export type RouteType = "cache" | "weak" | "strong";

export const CACHE_RETRIEVAL_COST = 0.00008;

export const RATE_CARD = {
    weak: { input: 0.0000011, output: 0.0000024 },
    strong: { input: 0.000012, output: 0.000024 },
} as const;

export const calculateCost = (route: RouteType, tokensIn: number, tokensOut: number): number => {
    if (route === "cache") {
        return CACHE_RETRIEVAL_COST;
    }

    const pricing = route === "strong" ? RATE_CARD.strong : RATE_CARD.weak;
    return tokensIn * pricing.input + tokensOut * pricing.output;
};

export const calculateSavings = (actualCost: number, baselineStrongCost: number) => {
    const absolute = Math.max(0, baselineStrongCost - actualCost);
    const percent = baselineStrongCost > 0 ? (absolute / baselineStrongCost) * 100 : 0;
    return { absolute, percent };
};
